// extracted by mini-css-extract-plugin
module.exports = {"image":"jwdm-module--image--3f1m5","imageRow":"jwdm-module--imageRow--A5oUq"};